/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import BankAccountService from "../../service/bank-account-service.js";
import ExcleJS from "exceljs";
import Pasoonate from "pasoonate";

const bankAccountService = new BankAccountService();

await loadDictionary("bank-account-import-bill-bank-account-window");

function ImportBillBankAccountWindow({isOpenWindow, onCloseWindow, bankAccountId}) {
  const [bankAccount, setBankAccount] = useState(null);
  const [transactions, setTransactions] = useState([]);

  const handleClose = () => {
    setBankAccount(null);

    onCloseWindow();
  };

  const handleSubmit = () => {
    bankAccountService.importTransactions(bankAccount, transactions).then(result => {
      if(result) {
        onCloseWindow();
      }
    }).catch(error => {
      console.error(error);
    });
  }

  const handleChangeFile = (event) => {
    const file = event.target.files[0];
    
    if (!file) return;

    const workbook = new ExcleJS.Workbook();
    workbook.xlsx.load(file.arrayBuffer()).then((workbook) => {
      
      if(!bankAccount) return;

      let transactions = [];

      switch(bankAccount.bank.acronym) {
        case "BSP":
          transactions = importSepahBankBill(workbook.getWorksheet(1))
        break;
        case "GAR":
          transactions = importTourismBankBill(workbook.getWorksheet(1))
        break;
      }

      setTransactions(transactions);            
    });
  };

  const importSepahBankBill = (worksheet) => {
    const transactions = [];

    worksheet.eachRow((row, rowNumber) => {
      if(rowNumber < 9 || !row.getCell(1).value) return;

      const statement = {
        date: Pasoonate.make().jalali().parse('yyyy/MM/dd HH:mm:s', row.getCell('B').value + ' ' + row.getCell('C').value).gregorian().format('yyyy-MM-dd HH:mm:ss'),
        debit_amount: row.getCell('G').value,
        credit_amount: row.getCell('F').value,
        description: row.getCell('E').text,
        balance: row.getCell('H').value,
        branch_code: null,
        branch_name: row.getCell('I').text,
        transaction_trace: row.getCell('N').text,
        transaction_identity: row.getCell('J').text,
        source_account: null,
        destination_account: null
      };

      transactions.push(statement);
    });

    return transactions;
  };

  const importTourismBankBill = (worksheet) => {
    const transactions = [];

    worksheet.eachRow((row, rowNumber) => {
      if(rowNumber < 3 || !row.getCell(1).value) return;

      const statement = {
        date: Pasoonate.make().jalali().parse('yyyy/MM/dd HH:mm', row.getCell('D').value + ' ' + row.getCell('E').value).setSecond(0).gregorian().format('yyyy-MM-dd HH:mm:ss'),
        debit_amount: row.getCell('J').value,
        credit_amount: row.getCell('K').value,
        description: row.getCell('I').text,
        balance: row.getCell('L').value,
        branch_code: row.getCell('B').text,
        branch_name: row.getCell('C').text,
        transaction_trace: null,
        transaction_identity: row.getCell('F').text,
        source_account: null,
        destination_account: null
      };

      transactions.push(statement);
    });

    return transactions;
  };

  useEffect(() => {
    if(!isOpenWindow || !bankAccountId) {
      return;
    }

    bankAccountService.findOne(bankAccountId).then(bankAccount => {
        if(bankAccount) {
            setBankAccount(bankAccount);
        }
    });
  }, [isOpenWindow, bankAccountId]);

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("bank-account-import-bill-bank-account-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="ImportBillForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
          <div className="row">
            <Form.Group className="mb-3 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-import-bill-bank-account-window.bank_account_name")}</Form.Label>
              <Form.Control type="text" defaultValue={bankAccount?.name} readOnly></Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col-12" controlId="">
              <Form.Label>{i18n.t("bank-account-import-bill-bank-account-window.file")}</Form.Label>
              <Form.Control type="file" onChange={handleChangeFile} ></Form.Control>
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("bank-account-import-bill-bank-account-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="ImportBillForm" >{i18n.t("bank-account-import-bill-bank-account-window.submit_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ImportBillBankAccountWindow;